import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Fieldset } from '../../shared/components/ui/fieldset/fieldset';
import { AppService } from '../../core/services/app.service';
import { NotificationItem } from './notification/notification';
import { TranslatePipe } from '@ngx-translate/core';
import { NotificationService } from '../../core/services/notification.service';

@Component({
  selector: 'andor-notifications-area',
  standalone: true,
  imports: [CommonModule, TranslatePipe, Fieldset, NotificationItem],
  templateUrl: './notifications-area.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './notifications-area.scss',
})
export class NotificationsArea implements OnDestroy {
  constructor(public notificationService: NotificationService) {
    notificationService.markNotificationsOpened();
  }

  ngOnDestroy() {
    this.notificationService.markNotificationsClosed();
  }
}
